import { Injectable } from '@angular/core';
import { ApiActions } from './util.service';
import { Subject } from 'rxjs';
import { Enquirylist } from 'src/app/model';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from './app-config.service';
import { MsgService } from './msg.service';
import { CommonDataService } from './common-data.service';
import { Router } from '@angular/router';
@Injectable({
  providedIn: 'root'
})
export class EnquirylistService {

  public pageName = 'Enquirylist';
  public dataList = new Subject<Array<Enquirylist>>();
  public singledataList = new Subject<Array<Enquirylist>>();

  constructor(
    private http: HttpClient,
    private config: AppConfigService,
    private common: CommonDataService,
		private msgSvc: MsgService,
		private router: Router
  ) { }

  private getUrl(apiOption: ApiActions) {
    return this.config.ipAddress + this.config.EnquirylistApi[apiOption];
  }

  public getDataRecords() {

    this.http.post(this.getUrl(ApiActions.Get), null, { headers: undefined })
      .subscribe((response: any) => {
        if (response && response.result) {
          const dataArray: Array<Enquirylist> = [];
          response.result.Enquiries.map(element => {
            element.status = element.rec_status + '' === '1' ? true : false;
            dataArray.push(element);
          });
          this.dataList.next(dataArray);
        }
      },
        err => {
            this.msgSvc.addErrorMsg({ summary: 'Login', detail: 'Token Expired Please Login Again.' });  setTimeout(() => { localStorage.clear();  this.router.navigate(['/account/login']); }, 1000);
        });
  }

  public getDataRecordsbyid(id:number) {
    const fData = new FormData();
    fData.append('enq_id', id + '');
    this.http.post(this.getUrl(ApiActions.Delete), fData, { headers: undefined })
      .subscribe((response: any) => {
        if (response && response.result) {
          const dataArray: Array<Enquirylist> = [];
          response.result.Enquirylist.map(element => {
            element.status = element.status == '1' ? true : false;
            dataArray.push(element);
          });
          this.singledataList.next(dataArray);
        }
      },
        err => {
            this.msgSvc.addErrorMsg({ summary: 'Login', detail: 'Token Expired Please Login Again.' });  setTimeout(() => { localStorage.clear();  this.router.navigate(['/account/login']); }, 1000);
        });
  }

  public addData(objData: Enquirylist) {
    const fData = new FormData();
    fData.append('enq_id', objData.enq_id + '');
	fData.append('user_id', objData.user_id + '');
  fData.append('prod_id', objData.prod_id + '');
	

    return this.common.executeAction(fData, this.getUrl(ApiActions.Create), this.pageName);
  }

  public updateData(objData: Enquirylist) {
    const fData = new FormData();
    fData.append('enq_id', objData.enq_id + '');
    
    fData.append('userid', objData.user_id + '');
    fData.append('prodid', objData.prod_id + '');
    
    return this.common.executeAction(fData, this.getUrl(ApiActions.Update), this.pageName);
  }

  public deleteData(id: number) {
    const fData = new FormData();
    fData.append('EnquirylistId', id + '');
    return this.common.executeAction(fData, this.getUrl(ApiActions.Delete), this.pageName);
  }

  public updateStatus(objData: Enquirylist) {
    const fData = new FormData();
    fData.append('stat', objData.status ? '1' : '0');
    fData.append('EnquirylistId', objData.enq_id + '');
    return this.common.executeAction(fData, this.getUrl(ApiActions.UpdateStatus), this.pageName);
  }
}
